<template>
  <!-- Flight -->
  <div
    :id="'flight_' + config.deviceFamilly.this_dev_id"
    class="flex h-[30px]"
    :class="{ popup: $root.isPopup }"
  >
    <div class="w-full flex items-center">
      <Flight_Flight
        v-if="Number.isInteger(config.flight.id)"
        :config="config"
      />
      <div v-else class="pl-2 text-base">
        #{{ config.drone.id }} - {{ config.drone.name }}
      </div>
    </div>

    <div
      class="p-[9.5px] h-full cursor-pointer aspect-square hover:bg-g1 mr-1"
      @click.stop.prevent="openPopup()"
      v-if="$root.user.can([2,3,4,5], 'DEVICES.open_popup')"
    >
      <svg
        class="fill-current"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 156.34 156.34"
      >
        <path
          d="M136.8,156.34h-39.09v-19.54h39.09v-39.09h19.54v58.63h-19.54ZM19.54,156.34H0v-58.63h19.54v39.09h39.09v19.54H19.54ZM136.8,68.63V19.54h-49.09V0h68.63v68.63h-19.54ZM0,58.63V0h58.63v19.54H19.54v39.09H0Z"
        />
        <rect
          x="94.87"
          y="-3.62"
          width="19.68"
          height="110.5"
          transform="translate(67.18 -58.92) rotate(45)"
        />
      </svg>
    </div>

    <div
      class="p-[9.5px] h-full cursor-pointer aspect-square hover:bg-g1 mr-1"
      @click.stop.prevent="config.reduce = !config.reduce"
    >
      <svg
        class="fill-current w-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 217.16 201.61"
      >
        <path
          v-if="config.reduce"
          d="M160.78,0H0v200h200V0h-39.22ZM160.78,157.75H39.22V42.25h121.56v115.51Z"
        />
        <rect v-else x="0" y="79.51" width="217.16" height="42.59" />
      </svg>
    </div>

    <div
      class="p-[9.5px] h-full cursor-pointer aspect-square hover:bg-g1 rounded-tr-[10px]"
      @click.stop.prevent="close()"
      v-if="$route.name != 'Site_FlightCurrent' && !$root.isPopup"
    >
      <svg
        class="fill-current w-full rotate-45"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 75 75"
      >
        <rect width="75" height="15" transform="translate(0 30)"></rect>
        <rect
          width="75"
          height="15"
          transform="translate(44.5) rotate(90)"
        ></rect>
      </svg>
    </div>
  </div>
</template>

<script>
import Flight_Flight from "@/partials/Device/Template/Flight/Flight_Flight.vue";

export default {
  name: "Flight_All",
  props: {
    config: Object,
  },
  components: {
    Flight_Flight,
  },
  setup() {
    return {};
  },

  mounted() {},

  methods: {
    close() {
      if (this.$route.name != "Site_FlightCurrent") {
        this.config.infoType = "small";
      }
    },

    openPopup() {
      this.config.methods.OpenPopup(this.config, this.video);
    },
  },
};
</script>
